<app-complex-modal-template
    confirmLabel="export"
    [canConfirm]="currentStepData().condition()"
    [stepNumber]="2"
    [title]="currentStepData().title"
    [(currentStep)]="currentStep"
    (onClickEvent)="onClickEvent($event)">
    @if (currentStep() === 1) {
        @if (depositFolderList().length && depositsFolderOptions().length) {
            <div class="py-7 w-1/2">
                <app-select-by-group
                    labelNoGroup="nonStandard"
                    placeholder="selectYourData"
                    [isMultiSelect]="true"
                    [label]="'data' | transloco"
                    [optionsByGroup]="optionsByGroup()"
                    [(selectedOptions)]="selectedDeposits" />
            </div>
        } @else {
            <app-loading />
        }
    } @else if (currentStep() === 2) {
        <app-export-deposit-modal-second-step
            #secondStep
            [selectedDeposits]="selectedDeposits()" />
    }
</app-complex-modal-template>
